import { message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  ButtonItem,
  InputItem,
  ErrorItem,
} from "../../../../Components/Items";

class EditarSubProyecto extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    visible: this.props.visible,
    subProyecto: this.props.subProyecto || {},  // Cargar datos iniciales del subproyecto
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.formRef.current.resetFields();
      this.consultarDatosSubProyecto(this.props.subProyecto._id);
    }
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  consultarDatosSubProyecto(id) {
    this.setState({ loading: true });
    axios
      .post(
        "subProyectos/datosSubProyecto",
        { subProyectoId: id },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.status === 404) {
          message.error("No se encontraron los datos del subproyecto");
        } else {
          const { codigo, nombre, descripcion } = res.data.subProyecto;
          this.formRef.current.setFieldsValue({
            codigo,
            nombre,
            descripcion,
          });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  }

  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "subProyectos/editarSubProyecto",
        {
          ...values,
          subProyectoId: this.props.subProyecto._id,
        },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("SubProyecto actualizado exitosamente");
          this.cerrarModal();
        } else {
          message.error("No se pudo actualizar el SubProyecto");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  }

  cerrarModal = () => {
    this.props.cerrarModal();
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
  };

  render() {
    return (
      <ModalItem
        title="Editar SubProyecto"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarModal}
        width={800}
      >
        <Form
          ref={this.formRef}
          name="modalEditarSubProyecto"
          layout
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
              loading={this.state.loading}
            >
              Guardar
            </ButtonItem>
          }
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          {/* Campo para el código del subproyecto */}
          <FormItem
            name="codigo"
            label="Codigo"
            required
            margin
          >
            <InputItem placeholder="Ingresa el código del subproyecto" />
          </FormItem>

          {/* Campo para el nombre del subproyecto */}
          <FormItem
            name="nombre"
            label="Nombre del SubProyecto"
            required
            margin
          >
            <InputItem placeholder="Ingresa el nombre del subproyecto" />
          </FormItem>

          {/* Campo para la descripción del subproyecto */}
          <FormItem
            name="descripcion"
            label="Descripción del SubProyecto"
            margin
          >
            <InputItem placeholder="Ingresa una breve descripción del subproyecto" />
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(EditarSubProyecto);
